import { FieldBase } from './field-base.model';
import { FormBase } from './form-base.model';
import { FieldOrFormCreator } from './field-or-form-creator.model';
import { FieldRule } from '@sb-tools/typescript/models/field-rule.model';
import { FieldUsedInModel } from '@sb-tools/typescript/models/field-used-in-model.model';
import { HttpRequestType } from '@sb-tools/typescript/enums/http-request-type.enum';

export class Field extends FieldBase {
    communityId: number;
    createdBy?: FieldOrFormCreator;
    createdByGuid?: string;
    defaultValue: string;
    dependantFields: Field[]; // gui only
    disabled: boolean; // gui only: used to disable field value in ng-select when it was already used (don't rename it!)
    fields: Field[]; // gui only
    formId: number;
    formsAffectedByChanging: FormBase[];
    groupId?: number;
    groupName: string; // gui only
    hasInvalidOption: boolean; // gui only
    isBasic: boolean;
    isDependant: boolean;
    isEditable: boolean; // gui only
    isExternalPossibleValues?: boolean;
    isGeneral: boolean;
    isGroupFieldsHidden: boolean; // gui only
    isGroupName: boolean; // gui only
    isHidden: boolean;
    isMapToTickedField: boolean; // it is needed for custom forms to filter basic fields
    isNameShown: boolean; // gui only
    isNeedToFocus: boolean; // gui only
    isPossibleValuesAllowed: boolean;
    isReadOnly?: boolean;
    isRequired: boolean;
    isRequiredForTeam: boolean;
    isResetToDefault: boolean;
    isSensitiveData: boolean;
    isShowGroupName: boolean; // gui only
    isShowedBecauseOfRule: boolean; // gui only
    isUsed: boolean;
    isUserIdentifier: boolean;
    label: string;
    level: number; // gui only
    options: any; // Dictionary < string, string >
    order: number;
    placeholder: string;
    possibleValuesRequestBody?: string;
    possibleValuesRequestHeaders?: string;
    possibleValuesRequestMethod?: HttpRequestType;
    possibleValuesRequestURL?: string;
    rootCategoryId: number;
    rules: FieldRule[];
    transformedValue: string; // gui only
    typeName: string; // gui only
    usedIn: FieldUsedInModel;
    usedInCount: number;
    value: any;
    valueModel: any; // gui only
}
